import request from "@/utils/request";

export function getOssConfigApi(data) {
  return request({
    url: "get_oss_config",
    method: "get",
    params:data,
  });
}
export function getOssAccessApi(data) {
  return request({
    url: "oss_access",
    method: "get",
    params:data,
  });
}
export function getUserPowerApi() {
  return request({
    url: "manage/business/staff/getUserPower",
    method: "get",
  });
}
// 奖励
export function increaseInteApi(data) {
  return request({
    url: "task_center/increaseInte",
    method: "post",
    data,
  });
}
// 奖励
export function giveCouponApi(data) {
  return request({
    url: "user/giveCoupon",
    method: "post",
    data,
  });
}
// 收货地址
export function userAddressApi(data) {
  return request({
    url: "user/address",
    method: "get",
    params:data,
  });
}
// 代金券
export function getCouponApi(data) {
  return request({
    url: "user/coupon",
    method: "get",
    params:data,
  });
}
// 搜索联系人
export function checkUserApi(data) {
  return request({
    url: "chatgroup/checkUser",
    method: "get",
    params:data,
  });
}

export function getTiandituKeyApi() {
  return request({
    url: "lbs/tdcodeTwo",
    method: "get",
  });
}


 